import { type RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    name: 'substances',
    path: '/substances',
    component: () => import('../pages/SubstanceDatabasesPage.vue'),
    meta: {
      requiresAuth: true
    },
    children: [
      {
        name: 'fertilizersTab',
        path: 'fertilizers',
        component: () => import('../../fertilizer/pages/FertilizerListPage.vue'),
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'pesticidesTab',
        path: 'pesticides',
        component: () => import('../../pesticide/pages/PesticideListPage.vue'),
        meta: {
          requiresAuth: true
        }
      },
      {
        name: 'seedsTab',
        path: 'seeds',
        component: () => import('../../seed/pages/SeedListPage.vue'),
        meta: {
          requiresAuth: true
        }
      }
    ]
  }
];

export default routes;
